var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _c(
        "div",
        { staticClass: "c_page-title" },
        [
          _c("div", [_vm._v("波次分播")]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticStyle: { "margin-left": "20px" },
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  _vm.initData()
                  _vm.machineStatusTableVisible = true
                }
              }
            },
            [_vm._v("查看设备状态")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "filter" },
        [
          _c(
            "el-col",
            [
              _c("el-collapse-transition", [
                _c("div", [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        background: "#f3f3f3",
                        height: "50px",
                        "line-height": "30px",
                        padding: "0 25px",
                        display: "flex",
                        "align-items": "center"
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "150px" },
                          attrs: { placeholder: "选择分播设备" },
                          on: { change: _vm.getCase },
                          model: {
                            value: _vm.machine_id,
                            callback: function($$v) {
                              _vm.machine_id = $$v
                            },
                            expression: "machine_id"
                          }
                        },
                        _vm._l(_vm.machines, function(item) {
                          return _c("el-option", {
                            key: item.machine_id,
                            attrs: {
                              label: item.machine_no,
                              value: item.machine_id
                            }
                          })
                        }),
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-select",
                        {
                          staticStyle: { margin: "0 20px" },
                          attrs: { placeholder: "选择分播类型" },
                          on: { change: _vm.getCase },
                          model: {
                            value: _vm.machine_cut_type,
                            callback: function($$v) {
                              _vm.machine_cut_type = $$v
                            },
                            expression: "machine_cut_type"
                          }
                        },
                        _vm._l(_vm.machine_cut_types, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.label, value: item.value }
                          })
                        }),
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "选择分播方案" },
                          on: { change: _vm.handleCutCaseChange },
                          model: {
                            value: _vm.machine_cut_case_id,
                            callback: function($$v) {
                              _vm.machine_cut_case_id = $$v
                            },
                            expression: "machine_cut_case_id"
                          }
                        },
                        _vm._l(_vm.machine_cut_cases, function(item) {
                          return _c("el-option", {
                            key: item.case_id,
                            attrs: {
                              value: item.case_id.toString(),
                              label: item.case_name
                            }
                          })
                        }),
                        1
                      ),
                      _vm._v(" "),
                      _vm.machine_cut_case &&
                      _vm.machine_cut_case.is_need_package === "1"
                        ? _c("el-input", {
                            ref: "refPackageInput",
                            staticStyle: { margin: "0 20px", width: "140px" },
                            attrs: {
                              placeholder: "请输入包裹号",
                              disabled: _vm.inputDisabled
                            },
                            on: { change: _vm.determineNotQZ },
                            nativeOn: {
                              keyup: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.setType.apply(null, arguments)
                              }
                            },
                            model: {
                              value: _vm.binding_package_no,
                              callback: function($$v) {
                                _vm.binding_package_no = $$v
                              },
                              expression: "binding_package_no"
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          staticStyle: { "margin-left": "20px" },
                          attrs: { type: "primary" },
                          on: { click: _vm.handleSwitchPackage }
                        },
                        [_vm._v("切换包裹")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          staticStyle: { "margin-left": "20px" },
                          attrs: { type: "success" },
                          on: { click: _vm.setType }
                        },
                        [_vm._v("开始分播")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "danger",
                            disabled: _vm.resData.machine_status != 1
                          },
                          on: {
                            click: function($event) {
                              return _vm.stopCut()
                            }
                          }
                        },
                        [_vm._v("结束分播")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          staticStyle: { "margin-left": "auto" },
                          attrs: { type: "primary", size: "mini" },
                          on: { click: _vm.fetchData }
                        },
                        [_vm._v("刷新页面")]
                      ),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v("最后刷新时间:" + _vm._s(_vm.resData.time))
                      ])
                    ],
                    1
                  )
                ])
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.set_machine.cut_type == -1
        ? _c("div", [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.is_1v8 == 1,
                    expression: "is_1v8 == 1"
                  }
                ]
              },
              _vm._l(_vm.resData.cut_data, function(item, index) {
                return _c("div", { key: index }, [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        width: "20%",
                        float: "left",
                        height: "10%",
                        margin: "0 auto",
                        "margin-left": "1%",
                        "margin-top": "10px",
                        border: "1px solid #3a8ee6",
                        "text-align": "center"
                      }
                    },
                    [
                      _c("p", { staticClass: "box_p" }, [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              float: "left",
                              "margin-left": "15px"
                            }
                          },
                          [_vm._v(_vm._s(item.picking_assignment_no))]
                        )
                      ]),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c("p", { staticClass: "box_p" }, [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              float: "left",
                              "margin-left": "15px"
                            }
                          },
                          [
                            _vm._v(
                              "已播/已拣/所需:" +
                                _vm._s(item.cut_num) +
                                "/" +
                                _vm._s(item.sm_num) +
                                "/" +
                                _vm._s(item.wave_picking_num)
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c("p", { staticClass: "box_p" }, [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              float: "left",
                              "margin-left": "15px"
                            }
                          },
                          [_vm._v("异常数量:" + _vm._s(item.yc_num))]
                        )
                      ]),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c("p", { staticClass: "box_p" }, [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              float: "left",
                              "margin-left": "15px"
                            }
                          },
                          [_vm._v("波次数量:" + _vm._s(item.wp_num))]
                        )
                      ]),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c(
                        "p",
                        [
                          _c(
                            "el-button",
                            {
                              staticStyle: {
                                float: "left",
                                "margin-left": "15px",
                                "margin-bottom": "15px"
                              },
                              attrs: { type: "success", size: "mini" },
                              on: {
                                click: function($event) {
                                  return _vm.showGrid(
                                    -1,
                                    item.picking_assignment_no
                                  )
                                }
                              }
                            },
                            [_vm._v("查看格口\n            ")]
                          )
                        ],
                        1
                      )
                    ]
                  )
                ])
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.is_1v8 == 0,
                    expression: "is_1v8 == 0"
                  }
                ]
              },
              [
                _c(
                  "div",
                  { staticStyle: { "margin-bottom": "0", width: "100%" } },
                  [
                    _vm.resData.cut_data
                      ? _c(
                          "el-button",
                          { attrs: { type: "primary", plain: "" } },
                          [_vm._v("拣货任务分播")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.resData.cut_data, function(item) {
                      return _c("div", [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              width: "20%",
                              float: "left",
                              height: "10%",
                              margin: "0 auto",
                              "margin-left": "1%",
                              "margin-top": "10px",
                              border: "1px solid #3a8ee6",
                              "text-align": "center"
                            }
                          },
                          [
                            _c("p", { staticClass: "box_p" }, [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    float: "left",
                                    "margin-left": "15px"
                                  }
                                },
                                [_vm._v("拣货单号:" + _vm._s(item.cut_no))]
                              )
                            ]),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c("p", { staticClass: "box_p" }, [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    float: "left",
                                    "margin-left": "15px"
                                  }
                                },
                                [
                                  _vm._v(
                                    "拣货方式:" +
                                      _vm._s(item.assignment_type_text) +
                                      " 波次类型:常规"
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c("p", { staticClass: "box_p" }, [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    float: "left",
                                    "margin-left": "15px"
                                  }
                                },
                                [
                                  _vm._v(
                                    "已播/已拣/所需:" +
                                      _vm._s(item.cut_num) +
                                      "/" +
                                      _vm._s(item.sm_num) +
                                      "/" +
                                      _vm._s(item.wave_picking_num)
                                  )
                                ]
                              ),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    float: "right",
                                    "margin-right": "15px"
                                  }
                                },
                                [_vm._v(_vm._s(item.cut_time) + "/s")]
                              )
                            ]),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c(
                              "p",
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: {
                                      float: "left",
                                      "margin-left": "15px",
                                      "margin-bottom": "15px"
                                    },
                                    attrs: { type: "success", size: "mini" },
                                    on: {
                                      click: function($event) {
                                        return _vm.showGrid(-1, item.cut_no, 1)
                                      }
                                    }
                                  },
                                  [_vm._v("查看格口\n              ")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: {
                                      float: "right",
                                      "margin-right": "15px"
                                    },
                                    attrs: { type: "danger", size: "mini" },
                                    on: {
                                      click: function($event) {
                                        return _vm.stopCut(item.cut_no, 1)
                                      }
                                    }
                                  },
                                  [_vm._v("结束分播\n              ")]
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ])
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "margin-bottom": "0",
                      width: "100%",
                      float: "left",
                      "margin-top": "20px"
                    }
                  },
                  [
                    _vm.resData.cut_data2
                      ? _c(
                          "el-button",
                          { attrs: { type: "primary", plain: "" } },
                          [_vm._v("汇总分播")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.resData.cut_data2, function(item) {
                      return _c("div", [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              width: "20%",
                              float: "left",
                              height: "10%",
                              margin: "0 auto",
                              "margin-left": "1%",
                              "margin-top": "10px",
                              border: "1px solid #3a8ee6",
                              "text-align": "center"
                            }
                          },
                          [
                            _c("p", { staticClass: "box_p" }, [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    float: "left",
                                    "margin-left": "15px"
                                  }
                                },
                                [_vm._v("汇总号:" + _vm._s(item.cut_no))]
                              )
                            ]),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c("p", { staticClass: "box_p" }, [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    float: "left",
                                    "margin-left": "15px"
                                  }
                                },
                                [
                                  _vm._v(
                                    "拣货方式:" +
                                      _vm._s(item.type_text) +
                                      "汇总 波次类型:" +
                                      _vm._s(item.type_text)
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c("p", { staticClass: "box_p" }, [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    float: "left",
                                    "margin-left": "15px"
                                  }
                                },
                                [
                                  _vm._v(
                                    "已播/已拣/所需:" +
                                      _vm._s(item.cut_num) +
                                      "/" +
                                      _vm._s(item.sm_num) +
                                      "/" +
                                      _vm._s(item.wave_picking_num)
                                  )
                                ]
                              ),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    float: "right",
                                    "margin-right": "15px"
                                  }
                                },
                                [_vm._v(_vm._s(item.cut_time) + "/s")]
                              )
                            ]),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c(
                              "p",
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: {
                                      float: "left",
                                      "margin-left": "15px",
                                      "margin-bottom": "15px"
                                    },
                                    attrs: { type: "success", size: "mini" },
                                    on: {
                                      click: function($event) {
                                        return _vm.showGrid(-1, item.cut_no, 2)
                                      }
                                    }
                                  },
                                  [_vm._v("查看格口\n              ")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: {
                                      float: "right",
                                      "margin-right": "15px"
                                    },
                                    attrs: { type: "danger", size: "mini" },
                                    on: {
                                      click: function($event) {
                                        return _vm.stopCut(item.cut_no, 2)
                                      }
                                    }
                                  },
                                  [_vm._v("结束分播\n              ")]
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ])
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "margin-bottom": "0",
                      width: "100%",
                      float: "left",
                      "margin-top": "20px"
                    }
                  },
                  [
                    _vm.resData.cut_data3
                      ? _c(
                          "el-button",
                          { attrs: { type: "primary", plain: "" } },
                          [_vm._v("中分任务分播")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.resData.cut_data3, function(item) {
                      return _c("div", [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              width: "20%",
                              float: "left",
                              height: "10%",
                              margin: "0 auto",
                              "margin-left": "1%",
                              "margin-top": "10px",
                              border: "1px solid #3a8ee6",
                              "text-align": "center"
                            }
                          },
                          [
                            _c("p", { staticClass: "box_p" }, [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    float: "left",
                                    "margin-left": "15px"
                                  }
                                },
                                [_vm._v("中分任务:" + _vm._s(item.cut_no))]
                              )
                            ]),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c("p", { staticClass: "box_p" }, [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    float: "left",
                                    "margin-left": "15px"
                                  }
                                },
                                [
                                  _vm._v(
                                    "拣货方式:" +
                                      _vm._s(item.picking_type) +
                                      " 波次类型:" +
                                      _vm._s(item.wave_type)
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c("p", { staticClass: "box_p" }, [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    float: "left",
                                    "margin-left": "15px"
                                  }
                                },
                                [
                                  _vm._v(
                                    "已播/已拣/所需:" +
                                      _vm._s(item.cut_num) +
                                      "/" +
                                      _vm._s(item.sm_num) +
                                      "/" +
                                      _vm._s(item.wave_picking_num)
                                  )
                                ]
                              ),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    float: "right",
                                    "margin-right": "15px"
                                  }
                                },
                                [_vm._v(_vm._s(item.cut_time) + "/s")]
                              )
                            ]),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c(
                              "p",
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: {
                                      float: "left",
                                      "margin-left": "15px",
                                      "margin-bottom": "15px"
                                    },
                                    attrs: { type: "success", size: "mini" },
                                    on: {
                                      click: function($event) {
                                        return _vm.showGrid(-1, item.cut_no, 3)
                                      }
                                    }
                                  },
                                  [_vm._v("查看格口\n              ")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: {
                                      float: "right",
                                      "margin-right": "15px"
                                    },
                                    attrs: { type: "danger", size: "mini" },
                                    on: {
                                      click: function($event) {
                                        return _vm.stopCut(item.cut_no, 3)
                                      }
                                    }
                                  },
                                  [_vm._v("结束分播\n              ")]
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ])
                    })
                  ],
                  2
                )
              ]
            )
          ])
        : _c(
            "div",
            _vm._l(_vm.resData.cut_data, function(item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticStyle: {
                    width: "20%",
                    float: "left",
                    height: "10%",
                    margin: "0 auto",
                    "margin-left": "1%",
                    "margin-top": "10px",
                    border: "1px solid #3a8ee6",
                    "text-align": "center"
                  }
                },
                [
                  _c("p", { staticClass: "box_p" }, [
                    _c(
                      "span",
                      { staticStyle: { float: "left", "margin-left": "15px" } },
                      [
                        _vm._v(
                          _vm._s(
                            {
                              1: "入库分播",
                              2: "按次品员",
                              3: "按中分位",
                              5: "按中分位分组",
                              "-2": "波次粗分"
                            }[_vm.set_machine.cut_type]
                          )
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("p", { staticClass: "box_p" }, [
                    _c(
                      "span",
                      { staticStyle: { float: "left", "margin-left": "15px" } },
                      [_vm._v("已播:" + _vm._s(item.cut_num))]
                    )
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("p", { staticClass: "box_p" }, [
                    _c(
                      "span",
                      { staticStyle: { float: "left", "margin-left": "15px" } },
                      [_vm._v("异常数量:" + _vm._s(item.yc_num))]
                    )
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "p",
                    [
                      _c(
                        "el-button",
                        {
                          staticStyle: {
                            float: "left",
                            "margin-left": "15px",
                            "margin-bottom": "15px"
                          },
                          attrs: { type: "success", size: "mini" },
                          on: {
                            click: function($event) {
                              return _vm.showGrid(_vm.set_machine.cut_type, "")
                            }
                          }
                        },
                        [_vm._v("查看格口")]
                      )
                    ],
                    1
                  )
                ]
              )
            }),
            0
          ),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _vm.is_1v8 == 1 && _vm.resData.grid_data.length > 0
        ? _c(
            "el-row",
            { staticStyle: { width: "100%", float: "left" } },
            [
              _c(
                "el-col",
                { attrs: { span: 1 } },
                [
                  _c("el-row", { staticClass: "line_y" }, [
                    _c("hr", { staticStyle: { border: "0" } })
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 1 } },
                [
                  _c("el-row", { staticClass: "line_left" }, [
                    _c("hr", { staticStyle: { border: "0" } })
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 1 } },
                [
                  _c("el-row", { staticClass: "line_right" }, [
                    _c("hr", { staticStyle: { border: "0" } })
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 1 } },
                [
                  _c("el-row", { staticClass: "line left-top" }, [
                    _c("hr", { staticStyle: { border: "0" } })
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 1 } },
                [
                  _c("el-row", { staticClass: "line left-bottom" }, [
                    _c("hr", { staticStyle: { border: "0" } })
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 1 } },
                [
                  _c("el-row", { staticClass: "line right-top" }, [
                    _c("hr", { staticStyle: { border: "0" } })
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 1 } },
                [
                  _c("el-row", { staticClass: "line right-bottom" }, [
                    _c("hr", { staticStyle: { border: "0" } })
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { staticStyle: { margin: "20px" }, attrs: { span: 6 } },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 40 } },
                    [
                      _c("el-col", { attrs: { span: 12 } }, [
                        _vm.checkGrid(_vm.resData.grid_data[0])
                          ? _c("div", [
                              _c(
                                "div",
                                { class: _vm.resData.grid_data[0].grid_style },
                                [
                                  _vm.showOnIn()
                                    ? _c("p", { staticClass: "pad" }, [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.resData.grid_data[0].box_no
                                            ) +
                                            "\n              "
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.showOnIn()
                                    ? _c(
                                        "p",
                                        { staticClass: "pad" },
                                        [
                                          _vm.resData.grid_data[0].box_no
                                            ? _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    size: "mini",
                                                    type: "primary"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.closeBox(
                                                        _vm.resData.grid_data[0]
                                                          .grid_no
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v("关闭容器")]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.showOnWaveRoughCut()
                                    ? _c(
                                        "p",
                                        { staticClass: "pad" },
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                size: "mini",
                                                type: "primary"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.pickGrid(
                                                    _vm.resData.grid_data[0]
                                                      .grid_no
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("提取格口")]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(_vm.resData.grid_data[0].grid_no)
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm.showOnIn() || _vm.showMedianGroupName()
                                    ? _c("p", { staticClass: "pad" }, [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.resData.grid_data[0].grid_type
                                            ) +
                                            "\n              "
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.resData.grid_data[0]
                                              .is_sc_grid == 1,
                                          expression:
                                            "resData.grid_data[0].is_sc_grid == 1"
                                        }
                                      ],
                                      staticClass: "pad"
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.machine_cut_type == 4
                                              ? "不出库"
                                              : "色差"
                                          ) +
                                          "\n              "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.resData.grid_data[0]
                                              .is_sc_grid == 2,
                                          expression:
                                            "resData.grid_data[0].is_sc_grid == 2"
                                        }
                                      ],
                                      staticClass: "pad"
                                    },
                                    [
                                      _vm._v(
                                        "\n                微次\n              "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "box_p" }, [
                                    _vm._v("\n                已播"),
                                    _vm.showOnWave()
                                      ? _c("span", [_vm._v("/所需")])
                                      : _vm._e(),
                                    _vm._v(
                                      ":\n                " +
                                        _vm._s(_vm.resData.grid_data[0].cut_num)
                                    ),
                                    _vm.showOnWave()
                                      ? _c("span", [
                                          _vm._v(
                                            "/" +
                                              _vm._s(
                                                _vm.resData.grid_data[0]
                                                  .wave_picking_num
                                              )
                                          )
                                        ])
                                      : _vm._e()
                                  ])
                                ]
                              )
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("el-col", { attrs: { span: 12 } }, [
                        _vm.checkGrid(_vm.resData.grid_data[1])
                          ? _c("div", [
                              _c(
                                "div",
                                { class: _vm.resData.grid_data[1].grid_style },
                                [
                                  _vm.showOnIn()
                                    ? _c("p", { staticClass: "pad" }, [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.resData.grid_data[1].box_no
                                            ) +
                                            "\n              "
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.showOnIn()
                                    ? _c(
                                        "p",
                                        { staticClass: "pad" },
                                        [
                                          _vm.resData.grid_data[1].box_no
                                            ? _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    size: "mini",
                                                    type: "primary"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.closeBox(
                                                        _vm.resData.grid_data[1]
                                                          .grid_no
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v("关闭容器")]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.showOnWaveRoughCut()
                                    ? _c(
                                        "p",
                                        { staticClass: "pad" },
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                size: "mini",
                                                type: "primary"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.pickGrid(
                                                    _vm.resData.grid_data[1]
                                                      .grid_no
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("提取格口")]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(_vm.resData.grid_data[1].grid_no)
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm.showOnIn() || _vm.showMedianGroupName()
                                    ? _c("p", { staticClass: "pad" }, [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.resData.grid_data[1].grid_type
                                            ) +
                                            "\n              "
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.resData.grid_data[1]
                                              .is_sc_grid == 1,
                                          expression:
                                            "resData.grid_data[1].is_sc_grid == 1"
                                        }
                                      ],
                                      staticClass: "pad"
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.machine_cut_type == 4
                                              ? "不出库"
                                              : "色差"
                                          ) +
                                          "\n              "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.resData.grid_data[1]
                                              .is_sc_grid == 2,
                                          expression:
                                            "resData.grid_data[1].is_sc_grid == 2"
                                        }
                                      ],
                                      staticClass: "pad"
                                    },
                                    [
                                      _vm._v(
                                        "\n                微次\n              "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "box_p" }, [
                                    _vm._v("\n                已播"),
                                    _vm.showOnWave()
                                      ? _c("span", [_vm._v("/所需")])
                                      : _vm._e(),
                                    _vm._v(
                                      ":" +
                                        _vm._s(_vm.resData.grid_data[1].cut_num)
                                    ),
                                    _vm.showOnWave()
                                      ? _c("span", [
                                          _vm._v(
                                            "/" +
                                              _vm._s(
                                                _vm.resData.grid_data[1]
                                                  .wave_picking_num
                                              )
                                          )
                                        ])
                                      : _vm._e()
                                  ])
                                ]
                              )
                            ])
                          : _vm._e()
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 40 } },
                    [
                      _c("el-col", { attrs: { span: 12 } }, [
                        _vm.checkGrid(_vm.resData.grid_data[2])
                          ? _c("div", [
                              _c(
                                "div",
                                { class: _vm.resData.grid_data[2].grid_style },
                                [
                                  _vm.showOnIn()
                                    ? _c("p", { staticClass: "pad" }, [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.resData.grid_data[2].box_no
                                            ) +
                                            "\n              "
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.showOnIn()
                                    ? _c(
                                        "p",
                                        { staticClass: "pad" },
                                        [
                                          _vm.resData.grid_data[2].box_no
                                            ? _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    size: "mini",
                                                    type: "primary"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.closeBox(
                                                        _vm.resData.grid_data[2]
                                                          .grid_no
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v("关闭容器")]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.showOnWaveRoughCut()
                                    ? _c(
                                        "p",
                                        { staticClass: "pad" },
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                size: "mini",
                                                type: "primary"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.pickGrid(
                                                    _vm.resData.grid_data[2]
                                                      .grid_no
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("提取格口")]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(_vm.resData.grid_data[2].grid_no)
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm.showOnIn() || _vm.showMedianGroupName()
                                    ? _c("p", { staticClass: "pad" }, [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.resData.grid_data[2].grid_type
                                            ) +
                                            "\n              "
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.resData.grid_data[2]
                                              .is_sc_grid == 1,
                                          expression:
                                            "resData.grid_data[2].is_sc_grid == 1"
                                        }
                                      ],
                                      staticClass: "pad"
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.machine_cut_type == 4
                                              ? "不出库"
                                              : "色差"
                                          ) +
                                          "\n              "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.resData.grid_data[2]
                                              .is_sc_grid == 2,
                                          expression:
                                            "resData.grid_data[2].is_sc_grid == 2"
                                        }
                                      ],
                                      staticClass: "pad"
                                    },
                                    [
                                      _vm._v(
                                        "\n                微次\n              "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "box_p" }, [
                                    _vm._v("\n                已播"),
                                    _vm.showOnWave()
                                      ? _c("span", [_vm._v("/所需")])
                                      : _vm._e(),
                                    _vm._v(
                                      ":" +
                                        _vm._s(_vm.resData.grid_data[2].cut_num)
                                    ),
                                    _vm.showOnWave()
                                      ? _c("span", [
                                          _vm._v(
                                            "/" +
                                              _vm._s(
                                                _vm.resData.grid_data[2]
                                                  .wave_picking_num
                                              )
                                          )
                                        ])
                                      : _vm._e()
                                  ])
                                ]
                              )
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("el-col", { attrs: { span: 12 } }, [
                        _vm.checkGrid(_vm.resData.grid_data[3])
                          ? _c("div", [
                              _c(
                                "div",
                                { class: _vm.resData.grid_data[3].grid_style },
                                [
                                  _vm.showOnIn()
                                    ? _c("p", { staticClass: "pad" }, [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.resData.grid_data[3].box_no
                                            ) +
                                            "\n              "
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.showOnIn()
                                    ? _c(
                                        "p",
                                        { staticClass: "pad" },
                                        [
                                          _vm.resData.grid_data[3].box_no
                                            ? _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    size: "mini",
                                                    type: "primary"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.closeBox(
                                                        _vm.resData.grid_data[3]
                                                          .grid_no
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v("关闭容器")]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.showOnWaveRoughCut()
                                    ? _c(
                                        "p",
                                        { staticClass: "pad" },
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                size: "mini",
                                                type: "primary"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.pickGrid(
                                                    _vm.resData.grid_data[3]
                                                      .grid_no
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("提取格口")]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(_vm.resData.grid_data[3].grid_no)
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm.showOnIn() || _vm.showMedianGroupName()
                                    ? _c("p", { staticClass: "pad" }, [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.resData.grid_data[3].grid_type
                                            ) +
                                            "\n              "
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.resData.grid_data[3]
                                              .is_sc_grid == 1,
                                          expression:
                                            "resData.grid_data[3].is_sc_grid == 1"
                                        }
                                      ],
                                      staticClass: "pad"
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.machine_cut_type == 4
                                              ? "不出库"
                                              : "色差"
                                          ) +
                                          "\n              "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.resData.grid_data[3]
                                              .is_sc_grid == 2,
                                          expression:
                                            "resData.grid_data[3].is_sc_grid == 2"
                                        }
                                      ],
                                      staticClass: "pad"
                                    },
                                    [
                                      _vm._v(
                                        "\n                微次\n              "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "box_p" }, [
                                    _vm._v("\n                已播"),
                                    _vm.showOnWave()
                                      ? _c("span", [_vm._v("/所需")])
                                      : _vm._e(),
                                    _vm._v(
                                      ":" +
                                        _vm._s(_vm.resData.grid_data[3].cut_num)
                                    ),
                                    _vm.showOnWave()
                                      ? _c("span", [
                                          _vm._v(
                                            "/" +
                                              _vm._s(
                                                _vm.resData.grid_data[3]
                                                  .wave_picking_num
                                              )
                                          )
                                        ])
                                      : _vm._e()
                                  ])
                                ]
                              )
                            ])
                          : _vm._e()
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                {
                  staticStyle: {
                    "font-size": "50px",
                    "margin-top": "20px",
                    "text-align": "center",
                    color: "black"
                  },
                  attrs: { span: 2 }
                },
                [_c("el-row", [_c("i", { staticClass: "el-icon-monitor" })])],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { staticStyle: { margin: "20px" }, attrs: { span: 6 } },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 40 } },
                    [
                      _c("el-col", { attrs: { span: 12 } }, [
                        _vm.checkGrid(_vm.resData.grid_data[4])
                          ? _c("div", [
                              _c(
                                "div",
                                { class: _vm.resData.grid_data[4].grid_style },
                                [
                                  _vm.showOnIn()
                                    ? _c("p", { staticClass: "pad" }, [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.resData.grid_data[4].box_no
                                            ) +
                                            "\n              "
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.showOnIn()
                                    ? _c(
                                        "p",
                                        { staticClass: "pad" },
                                        [
                                          _vm.resData.grid_data[4].box_no
                                            ? _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    size: "mini",
                                                    type: "primary"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.closeBox(
                                                        _vm.resData.grid_data[4]
                                                          .grid_no
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v("关闭容器")]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.showOnWaveRoughCut()
                                    ? _c(
                                        "p",
                                        { staticClass: "pad" },
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                size: "mini",
                                                type: "primary"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.pickGrid(
                                                    _vm.resData.grid_data[4]
                                                      .grid_no
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("提取格口")]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(_vm.resData.grid_data[4].grid_no)
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm.showOnIn() || _vm.showMedianGroupName()
                                    ? _c("p", { staticClass: "pad" }, [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.resData.grid_data[4].grid_type
                                            ) +
                                            "\n              "
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.resData.grid_data[4]
                                              .is_sc_grid == 1,
                                          expression:
                                            "resData.grid_data[4].is_sc_grid == 1"
                                        }
                                      ],
                                      staticClass: "pad"
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.machine_cut_type == 4
                                              ? "不出库"
                                              : "色差"
                                          ) +
                                          "\n              "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.resData.grid_data[4]
                                              .is_sc_grid == 2,
                                          expression:
                                            "resData.grid_data[4].is_sc_grid == 2"
                                        }
                                      ],
                                      staticClass: "pad"
                                    },
                                    [
                                      _vm._v(
                                        "\n                微次\n              "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "box_p" }, [
                                    _vm._v("\n                已播"),
                                    _vm.showOnWave()
                                      ? _c("span", [_vm._v("/所需")])
                                      : _vm._e(),
                                    _vm._v(
                                      ":" +
                                        _vm._s(_vm.resData.grid_data[4].cut_num)
                                    ),
                                    _vm.showOnWave()
                                      ? _c("span", [
                                          _vm._v(
                                            "/" +
                                              _vm._s(
                                                _vm.resData.grid_data[4]
                                                  .wave_picking_num
                                              )
                                          )
                                        ])
                                      : _vm._e()
                                  ])
                                ]
                              )
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("el-col", { attrs: { span: 12 } }, [
                        _vm.checkGrid(_vm.resData.grid_data[5])
                          ? _c("div", [
                              _c(
                                "div",
                                { class: _vm.resData.grid_data[5].grid_style },
                                [
                                  _vm.showOnIn()
                                    ? _c("p", { staticClass: "pad" }, [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.resData.grid_data[5].box_no
                                            ) +
                                            "\n              "
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.showOnIn()
                                    ? _c(
                                        "p",
                                        { staticClass: "pad" },
                                        [
                                          _vm.resData.grid_data[5].box_no
                                            ? _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    size: "mini",
                                                    type: "primary"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.closeBox(
                                                        _vm.resData.grid_data[5]
                                                          .grid_no
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v("关闭容器")]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.showOnWaveRoughCut()
                                    ? _c(
                                        "p",
                                        { staticClass: "pad" },
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                size: "mini",
                                                type: "primary"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.pickGrid(
                                                    _vm.resData.grid_data[5]
                                                      .grid_no
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("提取格口")]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(_vm.resData.grid_data[5].grid_no)
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm.showOnIn() || _vm.showMedianGroupName()
                                    ? _c("p", { staticClass: "pad" }, [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.resData.grid_data[5].grid_type
                                            ) +
                                            "\n              "
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.resData.grid_data[5]
                                              .is_sc_grid == 1,
                                          expression:
                                            "resData.grid_data[5].is_sc_grid == 1"
                                        }
                                      ],
                                      staticClass: "pad"
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.machine_cut_type == 4
                                              ? "不出库"
                                              : "色差"
                                          ) +
                                          "\n              "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.resData.grid_data[5]
                                              .is_sc_grid == 2,
                                          expression:
                                            "resData.grid_data[5].is_sc_grid == 2"
                                        }
                                      ],
                                      staticClass: "pad"
                                    },
                                    [
                                      _vm._v(
                                        "\n                微次\n              "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "box_p" }, [
                                    _vm._v("\n                已播"),
                                    _vm.showOnWave()
                                      ? _c("span", [_vm._v("/所需")])
                                      : _vm._e(),
                                    _vm._v(
                                      ":" +
                                        _vm._s(_vm.resData.grid_data[5].cut_num)
                                    ),
                                    _vm.showOnWave()
                                      ? _c("span", [
                                          _vm._v(
                                            "/" +
                                              _vm._s(
                                                _vm.resData.grid_data[5]
                                                  .wave_picking_num
                                              )
                                          )
                                        ])
                                      : _vm._e()
                                  ])
                                ]
                              )
                            ])
                          : _vm._e()
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 40 } },
                    [
                      _c("el-col", { attrs: { span: 12 } }, [
                        _vm.checkGrid(_vm.resData.grid_data[6])
                          ? _c("div", [
                              _c(
                                "div",
                                { class: _vm.resData.grid_data[6].grid_style },
                                [
                                  _vm.showOnIn() || _vm.showMedianGroupName()
                                    ? _c("p", { staticClass: "pad" }, [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.resData.grid_data[6].box_no
                                            ) +
                                            "\n              "
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.showOnIn()
                                    ? _c(
                                        "p",
                                        { staticClass: "pad" },
                                        [
                                          _vm.resData.grid_data[6].box_no
                                            ? _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    size: "mini",
                                                    type: "primary"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.closeBox(
                                                        _vm.resData.grid_data[6]
                                                          .grid_no
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v("关闭容器")]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.showOnWaveRoughCut()
                                    ? _c(
                                        "p",
                                        { staticClass: "pad" },
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                size: "mini",
                                                type: "primary"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.pickGrid(
                                                    _vm.resData.grid_data[6]
                                                      .grid_no
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("提取格口")]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(_vm.resData.grid_data[6].grid_no)
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm.showOnIn() || _vm.showMedianGroupName()
                                    ? _c("p", { staticClass: "pad" }, [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.resData.grid_data[6].grid_type
                                            ) +
                                            "\n              "
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.resData.grid_data[6]
                                              .is_sc_grid == 1,
                                          expression:
                                            "resData.grid_data[6].is_sc_grid == 1"
                                        }
                                      ],
                                      staticClass: "pad"
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.machine_cut_type == 4
                                              ? "不出库"
                                              : "色差"
                                          ) +
                                          "\n              "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.resData.grid_data[6]
                                              .is_sc_grid == 2,
                                          expression:
                                            "resData.grid_data[6].is_sc_grid == 2"
                                        }
                                      ],
                                      staticClass: "pad"
                                    },
                                    [
                                      _vm._v(
                                        "\n                微次\n              "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "box_p" }, [
                                    _vm._v("\n                已播"),
                                    _vm.showOnWave()
                                      ? _c("span", [_vm._v("/所需")])
                                      : _vm._e(),
                                    _vm._v(
                                      ":" +
                                        _vm._s(_vm.resData.grid_data[6].cut_num)
                                    ),
                                    _vm.showOnWave()
                                      ? _c("span", [
                                          _vm._v(
                                            "/" +
                                              _vm._s(
                                                _vm.resData.grid_data[6]
                                                  .wave_picking_num
                                              )
                                          )
                                        ])
                                      : _vm._e()
                                  ])
                                ]
                              )
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("el-col", { attrs: { span: 12 } }, [
                        _vm.checkGrid(_vm.resData.grid_data[7])
                          ? _c("div", [
                              _vm.checkGrid(_vm.resData.grid_data[7])
                                ? _c(
                                    "div",
                                    {
                                      class: _vm.resData.grid_data[7].grid_style
                                    },
                                    [
                                      _vm.showOnIn()
                                        ? _c("p", { staticClass: "pad" }, [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm.resData.grid_data[7]
                                                    .box_no
                                                ) +
                                                "\n              "
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.showOnIn()
                                        ? _c(
                                            "p",
                                            { staticClass: "pad" },
                                            [
                                              _vm.resData.grid_data[7].box_no
                                                ? _c(
                                                    "el-button",
                                                    {
                                                      attrs: {
                                                        size: "mini",
                                                        type: "primary"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.closeBox(
                                                            _vm.resData
                                                              .grid_data[7]
                                                              .grid_no
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [_vm._v("关闭容器")]
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.showOnWaveRoughCut()
                                        ? _c(
                                            "p",
                                            { staticClass: "pad" },
                                            [
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    size: "mini",
                                                    type: "primary"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.pickGrid(
                                                        _vm.resData.grid_data[7]
                                                          .grid_no
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v("提取格口")]
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.resData.grid_data[7].grid_no
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _vm.showOnIn() ||
                                      _vm.showMedianGroupName()
                                        ? _c("p", { staticClass: "pad" }, [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm.resData.grid_data[7]
                                                    .grid_type
                                                ) +
                                                "\n              "
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "p",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                _vm.resData.grid_data[7]
                                                  .is_sc_grid == 1,
                                              expression:
                                                "resData.grid_data[7].is_sc_grid == 1"
                                            }
                                          ],
                                          staticClass: "pad"
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.machine_cut_type == 4
                                                  ? "不出库"
                                                  : "色差"
                                              ) +
                                              "\n              "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "p",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                _vm.resData.grid_data[7]
                                                  .is_sc_grid == 2,
                                              expression:
                                                "resData.grid_data[7].is_sc_grid == 2"
                                            }
                                          ],
                                          staticClass: "pad"
                                        },
                                        [
                                          _vm._v(
                                            "\n                微次\n              "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("p", { staticClass: "box_p" }, [
                                        _vm._v("\n                已播"),
                                        _vm.showOnWave()
                                          ? _c("span", [_vm._v("/所需")])
                                          : _vm._e(),
                                        _vm._v(
                                          ":" +
                                            _vm._s(
                                              _vm.resData.grid_data[7].cut_num
                                            )
                                        ),
                                        _vm.showOnWave()
                                          ? _c("span", [
                                              _vm._v(
                                                "/" +
                                                  _vm._s(
                                                    _vm.resData.grid_data[7]
                                                      .wave_picking_num
                                                  )
                                              )
                                            ])
                                          : _vm._e()
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ])
                          : _vm._e()
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: "详情", visible: _vm.girdVisible },
          on: {
            "update:visible": function($event) {
              _vm.girdVisible = $event
            }
          }
        },
        [
          _vm.showOnWave()
            ? _c(
                "el-table",
                { attrs: { data: _vm.infoDetail } },
                [
                  _c("el-table-column", {
                    attrs: {
                      property: "wave_picking_no",
                      label: "波次号",
                      align: "center",
                      width: "150"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      property: "grid_no",
                      label: "格口",
                      align: "center",
                      width: "120",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "cut_dbids", label: "打标ID" }
                  })
                ],
                1
              )
            : _c(
                "el-table",
                { attrs: { data: _vm.infoDetail } },
                [
                  _c("el-table-column", {
                    attrs: {
                      property: "grid_no",
                      label: "格口号",
                      align: "center",
                      width: "150"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      property: "grid_type",
                      label: {
                        1: "格口类型",
                        2: "次品员",
                        3: "中分位",
                        5: "按中分位分组"
                      }[_vm.set_machine.cut_type],
                      align: "center",
                      width: "220",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "dbids", label: "打标ID" }
                  })
                ],
                1
              )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "设备使用状态",
            visible: _vm.machineStatusTableVisible
          },
          on: {
            "update:visible": function($event) {
              _vm.machineStatusTableVisible = $event
            }
          }
        },
        [
          _c(
            "el-table",
            { attrs: { data: _vm.machines } },
            [
              _c("el-table-column", {
                attrs: {
                  property: "machine_no",
                  label: "设备编号",
                  width: "150"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  property: "machine_status",
                  formatter: _vm.formatterMachineStatus,
                  label: "使用状态",
                  width: "200"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  property: "use_admin_name",
                  formatter: _vm.formatterUseAdminName,
                  label: "操作人"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5612eb47", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5612eb47","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/machine/machineCut.vue
// module id = null
// module chunks = 